export const LOAD_RANKING = "LOAD_RANKING";
export const LOAD_RANKING_SUCCESS = "LOAD_RANKING_SUCCESS";
export const LOAD_RANKING_FAILED = "LOAD_RANKING_FAILED";